import { createAction } from '@wix/communities-blog-client-common';

export const CLEAR_COMMENTS = 'comments/CLEAR';

export const clearComments = createAction(CLEAR_COMMENTS);
